import { Tokens } from '@okta/okta-auth-js';
import { OktaAuthOptions } from '@okta/okta-auth-js/lib/types/';

export interface PostLoginHandlers {
  onSuccess: (tokens?: Tokens) => void;
  onError: (err: Error) => void;
}

export interface AppOIDCConfig {
  b2bOidc: OktaAuthOptions;
  b2eOidc: OktaAuthOptions;
}

export interface UserProfile {
  email: string;
  firstName: string;
  lastName: string;
  sub: string;
}

export enum IdpType {
  OktaB2E = 'OKTA-B2E',
  OktaGDC = 'OKTA-B2B', // B2B
  OktaEwacs = 'OKTA-EWACS',
}